const PrivacyPolicy = () => {
	window.location.replace(
		"https://docs.google.com/document/d/1EFKPKeLpKHY8BNqMKW59qcsgsz0Sz0dGxMkpCMIRcqA/edit?usp=sharing"
	);

	return null;
};

export default PrivacyPolicy;
